import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

const SILENT_AUTH_MESSAGES = new Set([
	"ERR_SESSION_EXPIRED",
	"Invalid token. We'll try to assign a new one on next request"
]);

const toastError = err => {
	const errorMsg = err.response?.data?.message || err.response?.data?.error;
	const details = err.response?.data?.details || {};
	const fallbackMessage = String(err?.message || "").trim();
	const errorCode = String(err?.code || "");
	const isNetworkError =
		fallbackMessage === "Network Error" ||
		["ERR_NETWORK", "ECONNABORTED", "ETIMEDOUT"].includes(errorCode);
	const currentPath =
		typeof window !== "undefined" ? String(window.location.pathname || "") : "";
	if (errorMsg && SILENT_AUTH_MESSAGES.has(String(errorMsg))) {
		return;
	}

	if (String(errorMsg || "") === "ERR_NO_TICKET_FOUND" && !currentPath.startsWith("/tickets")) {
		return;
	}

	if (String(errorMsg || "") === "ERR_OTHER_OPEN_TICKET") {
		const assignedUserName = String(details.assignedUserName || "").trim();
		const queueName = String(details.queueName || "").trim();
		const ticketId = details.ticketId ? `#${details.ticketId}` : "";
		let message = i18n.t("backendErrors.ERR_OTHER_OPEN_TICKET");

		if (assignedUserName && queueName) {
			message = i18n.t("backendErrors.ERR_OTHER_OPEN_TICKET_WITH_USER_QUEUE", {
				user: assignedUserName,
				queue: queueName,
				ticket: ticketId,
			});
		} else if (assignedUserName) {
			message = i18n.t("backendErrors.ERR_OTHER_OPEN_TICKET_WITH_USER", {
				user: assignedUserName,
				ticket: ticketId,
			});
		} else if (queueName) {
			message = i18n.t("backendErrors.ERR_OTHER_OPEN_TICKET_WITH_QUEUE", {
				queue: queueName,
				ticket: ticketId,
			});
		}

		toast.error(message, {
			toastId: [
				errorMsg,
				details.ticketId || "",
				details.assignedUserId || "",
				details.queueId || "",
			].join(":"),
		});
		return;
	}

	if (isNetworkError) {
		toast.error(i18n.t("backendErrors.ERR_NETWORK_UNAVAILABLE"), {
			toastId: "ERR_NETWORK_UNAVAILABLE",
		});
	} else if (errorMsg) {
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
			});
		} else {
			toast.error(errorMsg, {
				toastId: errorMsg,
			});
		}
	} else {
		toast.error(fallbackMessage || "An error occurred!");
	}
};

export default toastError;
